/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, CardContent, Card, Box } from "@mui/material";
import ImageDeleteDialogPanel from "components/webpage-selector/dialog-delete/panels/delete-dialog-panel";
import ImageDeleteDialogActions from "components/webpage-selector/dialog-delete/actions/delete-dialog-actions";
import WebpageEditContext from "components/webpage-selector/context";

const WebpageDeleteDialog = (props) => {
    
    const deleteType = props.deleteType;
    
    const ctx = useContext(WebpageEditContext);
    const {
        openRemove,
        setOpenRemove,
        webpage,
        onWebpageRemoved
    } = ctx;
    
    const [selectedWebpage, setSelectedWebpage] = useState();
    useEffect(() => {
        setSelectedWebpage(webpage);
    }, [webpage]);
    
    const handleCancel = function () {
        setOpenRemove(false);
    };
    const handleRemove = () => {
        onWebpageRemoved(selectedWebpage);
        setOpenRemove(false);
    };

    return (
        <Fragment>
            <Dialog open={openRemove} onClose={handleCancel} fullWidth={true} maxWidth='lg'>
                <Card sx={{ display: "flex", width: "100%", height: "100%", borderRadius: 0, border: 0 }}>
                    <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
                            
                            <ImageDeleteDialogPanel deleteType={deleteType} />
                            
                        </Box>
                    </CardContent>
                </Card>

                <ImageDeleteDialogActions
                    deleteType={deleteType}
                    handleCancel={handleCancel}
                    handleRemove={handleRemove}
                />
            </Dialog>
        </Fragment>
    );
};

export { WebpageDeleteDialog };
